import React from "react";
import { ButtonPrimary, ButtonDanger } from "../../StyledComponent";

// import { ReactComponent as CheckIcon } from "../../../assets/novosicones/Financeiro/Check.svg";
import CloseIcon from "@material-ui/icons/CloseRounded";
import DoneIcon from "@material-ui/icons/DoneRounded";
import { Header, ModalWrapper } from "./styled";
import { BodyWrapper } from "./styled";
import RivaHeaderBackground from "../../../assets/novosicones/Financeiro/CartaoCredito/Background-azul-riva.png";
import DirecionalHeaderBackground from "../../../assets/novosicones/Financeiro/CartaoCredito/Background-azul-direcional.png";
import ErrorHeaderBackground from "../../../assets/novosicones/Financeiro/CartaoCredito/Background-vermelho.png";

export const infos = {
  Riva: {
    title: "Processando seu pagamento",
    message: `Seu pagamento está em <b> processo de aprovação </b> com o banco e pode levar até 48 horas para ser concluído.`,
  },
  Direcional: {
    title: "Processando seu pagamento",
    message: `Seu pagamento está em <b>processo de aprovação</b> com o banco e pode levar até 48 horas para ser concluído.`,
  },
  Erro: {
    title: "Transação não autorizada",
    message:
      "Se estiver com problemas entre em contato com sua operadora de cartão para maiores informações.",
  },
};

const ModalCardPaymentResult = ({
  tema,
  error,
  close,
  tryAgain,
  getParcelas,
}) => {
  const tipo = error
    ? "Erro"
    : !error && tema?.tipo === "Riva"
    ? "Riva"
    : "Direcional";

  const handleHeaderBackground = () => {
    if (tipo === "Erro") {
      return ErrorHeaderBackground;
    }
    if (tipo === "Direcional") {
      return DirecionalHeaderBackground;
    }
    return RivaHeaderBackground;
  };

  const handleIcon = () => {
    if (tipo === "Erro") {
      return <CloseIcon />;
    }

    return <DoneIcon />;
  };

  const handleSuccessClose = async () => {
    close();
    await getParcelas();
  };

  return (
    <ModalWrapper>
      <Header tema={tema}>
        <img src={handleHeaderBackground()} />
      </Header>
      <BodyWrapper tema={tema} error={error}>
        <div className="icon-container">{handleIcon()}</div>
        <span className="title">{infos[tipo]?.title}</span>

        <div
          className="message"
          dangerouslySetInnerHTML={{ __html: infos[tipo]?.message }}
        />
        <div className="container-buttons">
          {error && (
            <>
              <ButtonDanger fullWidth onClick={tryAgain}>
                TENTAR NOVAMENTE
              </ButtonDanger>
              <ButtonDanger fullWidth light onClick={close}>
                Fechar
              </ButtonDanger>
            </>
          )}
          {!error && (
            <ButtonPrimary
              tema={tema}
              error={error}
              fullWidth
              onClick={handleSuccessClose}
              light={error}
            >
              Fechar
            </ButtonPrimary>
          )}
        </div>
      </BodyWrapper>
    </ModalWrapper>
  );
};

export default ModalCardPaymentResult;
